import Skeleton from "@mui/material/Skeleton";

const InsightViewSkeleton = () => {
  return (
    <div className="bg-white w-full rounded-lg xl:col-span-4 col-span-12">
      <div>
        <Skeleton
          className="!bg-gray-300 rounded-t-lg"
          variant="rectangular"
          animation="wave"
          width={`w-full`}
          height={200}
        />
      </div>
      <div className="pl-2 pr-2 pt-4 flex justify-between">
        <div className="text-lg font-semibold text-skin-title-insights mb-2">
          <Skeleton
            className="!bg-gray-300"
            variant="text"
            animation="wave"
            width={140}
            height={36}
          />
        </div>
        <div>
          <div className="text-skin-icon-insights hover:text-skin-hover-icon-insights font-semibold">
            <Skeleton
              className="!bg-gray-300"
              variant="text"
              animation="wave"
              width={20}
              height={36}
            />
          </div>
        </div>
      </div>
      <div className="px-2">
        <Skeleton
          className="!bg-gray-300"
          variant="text"
          animation="wave"
          width={`w-full`}
          height={28}
        />
      </div>
      <div className="p-2 flex items-center">
        <Skeleton
          className="!bg-gray-300"
          animation="wave"
          variant="circular"
          width={56}
          height={56}
        />
        <div className="ml-2">
          <div className="text-sm text-skin-insights">
            <Skeleton
              className="!bg-gray-300"
              variant="text"
              animation="wave"
              width={70}
              height={20}
            />
          </div>
          <div className="text-sm text-skin-insights">
            <Skeleton
              className="!bg-gray-300"
              variant="text"
              animation="wave"
              width={70}
              height={20}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default InsightViewSkeleton;
